const pilots = {
  krzysztof: {
    name: 'Krzysztof',
    image: 'https://coolturystki.pl/lib/wyfaqa/krzysztof-coolturystki-strona-marketing-wyjazdy-mjpw9geu.webp',
  },

  patrycja: {
    name: 'Patrycja',
    image: '',
  },
}

export function getPilotById(pilotId) {
  return pilots[pilotId] ?? null
}